export default __webpack_public_path__ + "static/media/im-icon.4ccfc41d.svg";